import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet-async";
import Navbar from "./Navbar.jsx";
import { Button, TextField } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";

import { 
  getPDFData, 
  setPDFData, 
  savePDFData, 
} from "../redux/pdfSlice";

import {
  getUploadProfiles,
  doLogout,
  uploadProfilePicture,
  changePass,
} from "../redux/authSlice";
import { toast } from "react-toastify";


export default function Profile() {
  const dispatch = useDispatch();
  const [showChangePass, setShowChangePass] = useState(false);
  const [oldPass, setOldPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [newPass2, setNewPass2] = useState("");
  const userName = localStorage.getItem("userName");
  const pdfData = useSelector((state) => state?.pdf?.data);

  useEffect(() => {
    dispatch(getPDFData());
  }, [dispatch]);

  const updatePDFData = async (data) => {
    const newData={...pdfData, ...data};
    await dispatch(setPDFData(newData));
    await dispatch(savePDFData({pdfData: newData}));
  }

  const changeUploadPDF = async (e) => {
    await updatePDFData({upload:(e.target.value==="yes")});
    toast.info("Profile updated");
  }

  const handleLogout = async () => {
    await dispatch(doLogout());
  };

  const handleChangePassword = async () => {
    if (newPass !== newPass2) return toast.error("New passwords don't match");
    if (newPass.length <=7 ) return toast.error("New password must be over 7 characters long");
    const res = await dispatch(changePass({oldPassword: oldPass, newPassword: newPass}));
    if (res?.payload?.message) {
      toast.success(res.payload.message);
      showChangePass(false);
    } else if (res?.payload?.error) {
      toast.error(res.payload.error);
    } else {
      toast.error("failed to change password");
    }
  }

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("profilePhoto", new Blob([file]));
      formData.append("filename", file.name);
      try {
        await dispatch(uploadProfilePicture(formData));
        toast.success("Image uploaded successfully");
        dispatch(getUploadProfiles());
      } catch (error) {
        toast.error("Failed to upload image");
        console.error("Error uploading image:", error);
      }
    }
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <meta
          name="description"
          content="Edit your profile"
        />
        <title>Wedding Invitations &amp; RSVP Platform</title>
      </Helmet>
      <div>
        <Navbar />
        <div className="crl"></div>
        <div className="container card-b-1">
          <div className="row">
            <h6 className="col-md-12 welcome-text">
              <h4 className="heading">Profile</h4>
              <br></br>
            </h6>
          </div>
          <div className="add-eventapp-btn ">
          </div>
          <div className="crl"></div>
        </div>
        <div className="crl"></div>
        <div className="main-container">
          <div className="container bg-w">

            <div class="row">
              <div class="col py-3">
                <h3>{userName.replace(/"/g,'')}</h3>
              </div>
            </div>

            <div class="row">
              <div class="col py-3">
                <RadioGroup
                    value={(pdfData.upload===true) ? "yes" : "no"}
                    onChange={changeUploadPDF}
                  >
                  <FormControlLabel value="yes" control={<Radio />} label="Upload your full invitation PDF"/>
                  <FormControlLabel value="no" control={<Radio />} label="Use automatically generated invitation PDF" />
                </RadioGroup>
              </div>
            </div>

            <div class="row">
              <div class="col py-3">
                <Button variant="contained" component="label" onChange={handleFileChange}>
                  Change Picture
                  <input type="file" hidden />
                </Button>
              </div>
            </div>

            <div class="row">
              <div class="col py-3">
                {showChangePass ? <div className="my-3" style={{
                    backgroundColor:"#fff",
                    borderRadius:"12px",
                    display:"inline-block",
                    padding: "18px"
                  }}>
                  <TextField variant="outlined"
                    type="password"
                    label="Old password"
                    autoComplete="current-password"
                    value={oldPass}
                    onChange={(e)=>setOldPass(e.target.value)}
                  ></TextField><br></br>
                  <TextField variant="outlined"
                    label="New password"
                    autoComplete="new-password"
                    type="password"
                    value={newPass}
                    onChange={(e)=>setNewPass(e.target.value)}
                  ></TextField><br></br>
                  <TextField variant="outlined"
                    label="Confirm new password"
                    autoComplete="new-password"
                    type="password"
                    value={newPass2}
                    onChange={(e)=>setNewPass2(e.target.value)}
                    error={(newPass!==newPass2)}
                    helperText={(newPass!==newPass2) ? "password mismatch" : ""}
                    className="mb-3"
                  ></TextField><br></br>
                  <Button variant="contained" 
                    onClick={()=>setShowChangePass(old=>!old)}
                    className="me-3">
                      Cancel
                  </Button>
                  <Button variant="contained" 
                    onClick={handleChangePassword}>
                      Change Password
                  </Button>
                </div> : 
                  <Button variant="contained"
                    onClick={()=>setShowChangePass(old=>!old)}>
                      Change Password
                  </Button>
                }
              </div>
            </div>

            <div class="row">
              <div class="col py-3">
                <Button variant="contained" onClick={handleLogout}>Logout</Button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}
